import { AXIOS } from "customAxios"
import { FetchAccountGroupsRequest, NewAccountGroupBasicDetailsRequest, NewAccountGroupOtherDetailsRequest, SaveNewAccountGroupRequest } from "./types"

export const getAccountGroups = async (payload: FetchAccountGroupsRequest) => {
    return await AXIOS.get('/api/subClient/customer/dashboard/changeCustomerAccountGroup/initData/fetchAccountGroups', {
        params: payload
    })
}

export const getNewAccountGroupBasicDetails = async (payload: NewAccountGroupBasicDetailsRequest) => {
    return await AXIOS.get('/api/subClient/customer/dashboard/changeCustomerAccountGroup/newAccountGroup/fetchBasicDetails', {
        params: payload
    })
}

export const getNewAccountGroupOtherDetails = async (payload: NewAccountGroupOtherDetailsRequest) => {
    return await AXIOS.get('/api/subClient/customer/dashboard/changeCustomerAccountGroup/newAccountGroup/fetchOtherDetails', {
        params: payload
    })
}

export const saveNewAccountGroupDetails = async (payload: SaveNewAccountGroupRequest) => {
    return await AXIOS.post('/api/subClient/changeCustomerAccountGroup/save', payload)
}


